import styled from "styled-components";
import Box from "@material-ui/core/Box";
import Dialog from "@material-ui/core/Dialog";
import CheckIcon from "@material-ui/icons/Check";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ButtonBase from "@material-ui/core/ButtonBase";
import Button from "@material-ui/core/Button";
import red from "@material-ui/core/colors/red";
import green from "@material-ui/core/colors/green";
import Fab from "@material-ui/core/Fab";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";

export const MOBILE_BREAK_POINT = "1280px";
export const MOBILE_BREAK_POINT_SMALL = "840px";
export const MOBILE_BREAK_POINT_X_SMALL = "560px";

export const StyledControlPanel = styled(Box)`
  width: 480px;
  margin: 16px;
  height: calc(100% - 32px);
  background: #ffffff;
  border-radius: 32px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  @media (max-width: ${MOBILE_BREAK_POINT}) {
    position: absolute;
    margin: 0;
    left: 0;
    right: 0;
    top: calc(100% - 74px);
    width: auto;
    transition: top 400ms;
    height: auto;

    h3 {
      font-size: 1.2rem;
    }

    &.opened {
      top: 10%;
      bottom: 0;
      transition-timing-function: ease-in-out;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
`;

export const StyledCircleButton = styled(ButtonBase)`
  background: rgba(2, 62, 217, 0.2);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  padding: 9px;

  img,
  svg {
    width: 100%;
  }

  svg {
    height: 100%;
  }

  &.big {
    width: 70px;
    height: 70px;
    padding: 20px;
  }
`;

export const StyledSeparator = styled(Box)`
  height: 1px;
  width: 100%;
  background: #e5e5e5;
`;

export const StyledLogo = styled.img`
  width: 40px;
  height: 40px;
`;

export const StyledLogoContainer = styled.div`
  cursor: pointer;
`;

export const StyledHeaderActions = styled.div`
  position: absolute;
  top: 36px;
  left: 12px;
  right: ${({ autoWidth }) => (autoWidth ? "480px" : "12px")};
  padding: 16px 36px;
  display: flex;
  flex-direction: row;
  align-items: center;
  z-index: 1;
  background: ${({ inverted }) =>
    inverted ? "rgba(255,255,255,0.5)" : "none"};
  backdrop-filter: ${({ inverted }) => (inverted ? "blur(8px)" : "")};
  border-radius: 28px;

  &:not(.disable-query) {
    @media (max-width: ${MOBILE_BREAK_POINT}) {
      top: 0;
      left: 0;
      right: 0;
      padding: 16px ${({ theme }) => theme.spacing()}px;
      border-radius: 0;

      &.locked {
        position: static;
        background: white;
      }
    }
  }
`;

export const StyledVerticalSeparator = styled.div`
  width: 1px;
  height: 40px;
  background: #c4c4c4;
  margin: 0 24px;
`;

export const StyledColor = styled(Box)`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #${({ color }) => color};
  cursor: pointer;
  border: ${({ border }) => (border ? "1px solid #E5E5E5" : "none")}
  position: relative;

  &:hover {
    box-shadow: 0px 1px 2px rgba(30, 29, 60, 0.2);
  }

  @media (max-width: ${MOBILE_BREAK_POINT}) {
    width: 32px;
    height: 32px;
  }
`;

export const StyledActionCard = styled(Box)`
  padding: 0 ${({ theme }) => theme.spacing()}px;
  background: #f3f3f3;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  cursor: pointer;

  > div:first-child {
    min-height: 56px;
  }
`;

export const StyledSelectedImage = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 120px;
  overflow: hidden;

  img {
    height: 100%;
  }
`;

export const StyledLoaderWrapper = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  backdrop-filter: blur(12px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  > div {
    width: 40px;
    height: 40px;
  }
`;

export const StyledControlButtons = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 480px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${({ theme }) => theme.spacing() * 2}px;

  @media (max-width: ${MOBILE_BREAK_POINT}) {
    display: none;
  }
`;

export const StyledControlButton = styled(Box)`
  width: 64px;
  height: 64px;
  border: 2px solid ${({ theme }) => theme.palette.primary.main};
  box-sizing: border-box;
  border-radius: 50%;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.primary.main};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  transform: ${({ rotate }) => (rotate ? "rotate(180deg)" : "rotate(0deg)")};

  &:hover {
    background-color: ${({ theme }) => theme.palette.primary.main};
    color: #ffffff;
  }
`;

export const StyledAltButton = styled(ButtonBase)`
  background: #ffffff;
  border-radius: 20px;
  flex-basis: 53%;
  height: 40px;
  font-weight: bold;
  font-size: 12px;
  color: ${({ theme }) => theme.palette.primary.main};
  text-transform: uppercase;
  &:hover {
    box-shadow: 0px 2px 4px -1px rgb(0 0 0 / 20%),
      0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%);
  }
  svg {
    margin-right: 8px;
  }
`;

export const ModelSelectionBox = styled(Box)`
  box-sizing: border-box;
  height: 100%;
  display: flex;
  padding: ${({ theme }) => theme.spacing() * 4}px
    ${({ theme }) => theme.spacing() * 2}px
    ${({ theme }) => theme.spacing() * 2}px;
  flex-direction: row;
  margin: 0 auto;
  align-items: center;

  .show-more {
    display: none;
  }

  > div {
    > div:nth-child(3) {
      justify-content: center;
    }
  }

  @media (max-width: ${MOBILE_BREAK_POINT}) {
    padding: ${({ theme }) => theme.spacing() * 2}px 0 0;
    h4 {
      flex: 1;
    }
    > div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      > a,
      > h2,
      > h4 {
        padding: 0 ${({ theme }) => theme.spacing()}px;
        display: inline-block;
      }

      > div:nth-child(3) {
        align-items: center;
      }
      > div:last-child {
        padding: 0 ${({ theme }) => theme.spacing()}px;
        overflow-x: auto;
        overflow-y: hidden;
        box-sizing: border-box;
      }
    }
  }

  @media (max-width: ${MOBILE_BREAK_POINT_SMALL}) {
    width: 100%;
    margin: 0;

    .show-more {
      display: flex;
    }
    > div {
      width: 100%;
      height: 100%;
      > div:nth-child(3) {
        justify-content: flex-start;
      }
    }
  }
`;

export const SummaryViewBoxWrapper = styled(Box)`
  height: 100%;
  &:not(.disable-query) {
    @media (max-width: ${MOBILE_BREAK_POINT}) {
      overflow-y: auto;
    }
  }
`;

export const SummaryViewBox = styled(Box)`
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  display: flex;
  padding: ${({ theme }) => theme.spacing() * 5}px
    ${({ theme }) => theme.spacing() * 2}px
    ${({ theme }) => theme.spacing() * 2}px;

  flex-direction: row;
  margin: 0 auto;
  align-items: center;
  background: white;
  > div {
    flex: 1;
  }
  &:not(.disable-query) {
    @media (max-width: ${MOBILE_BREAK_POINT}) {
      flex-direction: column;
      padding-left: 0;
      padding-right: 0;
      padding-bottom: ${({ theme }) => theme.spacing() * 3}px;
      padding-top: ${({ theme }) => theme.spacing()}px;
    }
  }
`;

export const StyledSummaryImageWrapper = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  height: 100%;

  > div {
    display: flex;
    flex-direction: column;
    flex-basis: 50%;
    align-items: center;
    box-sizing: border-box;
    position: relative;

    span {
      position: absolute;
      top: ${({ theme }) => theme.spacing() / 1.5}px;
      margin: 0 auto;
      text-transform: uppercase;
      font-weight: 600;
      padding: 4px 16px;
      background: #cddaf9;
      border-radius: 16px;
      font-weight: 600;
      font-size: 0.8125rem;
      color: ${({ theme }) => theme.palette.primary.main};
    }

    &:nth-child(1n) {
      padding: 0 ${({ theme }) => theme.spacing()}px
        ${({ theme }) => theme.spacing()}px 0;
    }

    &:nth-child(2n) {
      padding: 0 0 ${({ theme }) => theme.spacing()}px 0;
    }

    &:nth-child(3n) {
      padding-bottom: 0;
    }

    &:last-child {
      padding-bottom: 0;
    }

    > div {
      border-radius: 32px;
      flex: 1;

      > div {
        height: 100%;
      }
    }
  }

  > div > div,
  > div > div > div {
    width: 100%;
    background-size: auto 100%;
    background-position: center bottom;
    background-repeat: no-repeat;
    padding-top: ${({ theme }) => theme.spacing() / 2}px;
  }
  &:not(.disable-query) {
    @media (max-width: ${MOBILE_BREAK_POINT}) {
      width: 100%;
      flex-wrap: nowrap;
      overflow-x: auto;
      height: auto;
      flex: none !important;
      margin-bottom: 36px;
      > div {
        width: 260px;
        height: 300px;
        flex: none;
        padding: 0 !important;
        margin-right: ${({ theme }) => theme.spacing()}px;
        &:first-child {
          margin-left: ${({ theme }) => theme.spacing()}px;
        }

        &:last-child {
          padding-right: ${({ theme }) => theme.spacing()}px!important;
          width: calc(300px + ${({ theme }) => theme.spacing()}px);
        }
      }
    }
  }
`;

export const StyledSummaryInfo = styled(Box)`
  background: #f3f3f3;
  border-radius: 32px;
  height: 100%;
  overflow-y: auto;
  margin-left: ${({ theme }) => theme.spacing()}px;
  padding: ${({ theme }) => theme.spacing() * 1.5}px;
  box-sizing: border-box;
  &:not(.disable-query) {
    @media (max-width: ${MOBILE_BREAK_POINT}) {
      margin-left: 0;
      overflow: initial;
      height: auto;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
`;

export const StyledModelCard = styled(Box)`
  background: #ffffff;
  border-radius: 32px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  padding-top: ${({ theme }) => theme.spacing()}px;
  padding-bottom: ${({ theme }) => theme.spacing()}px;
  width: 320px;
  height: 400px;

  img {
    width: 320px;
  }

  > div:last-child {
    opacity: 0;
    display: flex;
    transition: opacity 150ms;
    transition-delay: 50ms;
    transition-timing-function: ease-out;
  }

  @media (max-width: ${MOBILE_BREAK_POINT}) {
    width: 260px;
    height: 350px;
    img {
      width: 260px;
    }
  }

  @media (min-width: ${MOBILE_BREAK_POINT_X_SMALL}) {
    transition: width 250ms;
    transition-delay: 150ms;
    transition-timing-function: ease-out;

    &:hover {
      box-shadow: 0px 32px 64px rgba(8, 7, 30, 0.2);
      width: 550px;

      > div:last-child {
        opacity: 1;
        transition: opacity 100ms;
        transition-delay: 400ms;
        transition-timing-function: ease-out;
      }
    }
  }
`;

export const StyledActionArrow = styled(Box)`
  position: absolute;
  top: ${({ theme }) => theme.spacing()}px;
  left: ${({ theme }) => theme.spacing()}px;
  right: ${({ theme }) => theme.spacing()}px;
  display: flex;
`;

export const StyledColorDialog = styled(Dialog)`
  .MuiDialog-paper {
    padding: ${({ theme }) => theme.spacing()}px;
  }
`;

export const StyledRedirectToSummaryButton = styled(Box)`
  position: absolute;
  bottom: ${({ theme }) => theme.spacing()}px;
  right: ${({ theme }) => theme.spacing()}px;
  z-index: 1;

  @media (max-width: ${MOBILE_BREAK_POINT}) {
    left: ${({ theme }) => theme.spacing()}px;

    > .MuiChip-root {
      width: 100%;
      height: 40px;
    }
  }
`;

export const StyledPreviewModeButton = styled(Fab)`
  position: absolute;
  bottom: ${({ theme }) => theme.spacing() * 4}px;
  right: ${({ theme }) => theme.spacing()}px;
  z-index: 99;
`;

export const SummaryViewWrapper = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background: ${({ dark }) => (dark ? "black" : "transparent")};

  &.centered {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    > div > img {
      width: 100%;

      &:last-child {
        position: absolute;
        left: 0;
        right: 0;
        top: 5%;
        margin: 0 auto;
        height: 95%;
        width: auto;
      }
    }
  }
`;

export const StyledSummaryLoader = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: #f3f3f3;
`;

export const StyledBgrdLoader = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(12px);
  background: rgba(255, 255, 255, 0.55);
`;

export const StyledStatCard = styled(Box)`
  background: #ffffff;
  border-radius: 8px;
  flex-basis: 50%;
  padding: ${({ theme }) => theme.spacing()}px;
  box-sizing: border-box;
`;

export const StyledBigButton = styled(ButtonBase)`
  background: #ffffff;
  border-radius: 8px;
  width: 100%;
  padding: ${({ theme }) => theme.spacing() / 1.5}px;
  box-sizing: border-box;
  color: ${({ theme }) => theme.palette.primary.main};
  font-weight: 800;
`;

export const StyledColorCheckIcon = styled(CheckIcon)`
  position: absolute;
  top: 8px;
  left: 8px;

  @media (max-width: ${MOBILE_BREAK_POINT}) {
    top: 4px;
    left: 4px;
  }
`;

export const StyledCheckCircleIcon = styled(CheckCircleIcon)`
  color: ${({ theme }) => theme.palette.primary.main};
  margin-bottom: 16px;
  font-size: 74px;
`;

export const StyledControlsOverlayCover = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(4px);
  display: none;

  @media (max-width: ${MOBILE_BREAK_POINT}) {
    &.opened {
      display: block;
    }
  }
`;

export const StyledApproveButton = styled(Button)`
  ${({ showSelectedStyles }) => showSelectedStyles} {
    &:disabled {
      color: ${green[700]};
      border: 1px solid ${green[700]};
    }
  }
`;

export const StyledRejectButton = styled(Button)`
  ${({ showSelectedStyles }) => showSelectedStyles} {
    &:disabled {
      color: ${red[500]};
      border: 1px solid ${red[500]};
    }
  }
`;

export const StyledTableImage = styled.img`
  width: 100%;
  height: 100%;
  cursor: pointer;
  box-shadow: 0px 1px 2px rgba(30, 29, 60, 0.5);
  object-fit: cover;
`;

export const StyledImageContainer = styled(Paper)`
  width: 80px;
  height: 80px;
  background-image: ${({ background }) => `url(${background})`};
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
  background-color: ${({ background }) =>
    background ? "transparent" : "#f3f3f3"};
`;

export const StyledModalImageContainer = styled.img`
  width: 100%;
  height: 100%;
  background-image: ${({ background }) => `url(${background})`};
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
  background-color: ${({ background }) =>
    background ? "transparent" : "#f3f3f3"};
`;

export const StyledTableContainer = styled(TableContainer)`
  height: 90%;
  width: 90%;
  display: flex;
  flex-direction: column;

  @media (max-width: ${MOBILE_BREAK_POINT}) {
    min-height: 100%;
    width: 100%;
  }
`;
export const StyledWaterMarkContainer = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0.4;
  > img {
    height: 50%;
  }
`;

export const StyledLoaderOverlay = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 3;
  background-color: rgba(255, 255, 255, 0.6);
`;

export const StyledTextField = styled(TextField)`
  margin-top: 4px;
  margin-bottom: 24px;
  margin-right: 14px;

  .MuiInputBase-root.MuiOutlinedInput-root {
    border-radius: 8px;
    font-size: 14px;
  }

  .MuiOutlinedInput-input {
    padding: 12px;
    font-size: 14px;
  }

  .MuiInputLabel-root.Mui-focused {
    color: ${({ theme }) => theme.palette.primary.main};
  }

  .MuiInputBase-input:focus {
    border-radius: 0;
  }
`;

export const StyledFormLabel = styled(Typography)`
  font-size: 14px;
  ${({ required, theme }) =>
    required
      ? `:after {
    content: "*";
    color: ${theme.palette.error.main};
  }`
      : null};
`;

export const StyledCoverOverlay = styled(Box)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(8px);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const StyledDivider = styled(Divider)`
  margin-top: 10px;
  margin-bottom: 10px;
`;
